import {
  chakra,
  CheckboxGroup as ChakraUiCheckboxGroup,
} from '@chakra-ui/react';

export const CheckboxGroup = chakra(ChakraUiCheckboxGroup);
